import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_7159d61d from 'nuxt_plugin_plugin_7159d61d' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_vlazyload_9959e13e from 'nuxt_plugin_vlazyload_9959e13e' // Source: ./v-lazy-load.js (mode: 'all')
import nuxt_plugin_nuxtsvgsprite_db2f47de from 'nuxt_plugin_nuxtsvgsprite_db2f47de' // Source: ./nuxt-svg-sprite.js (mode: 'all')
import nuxt_plugin_axios_5242f69a from 'nuxt_plugin_axios_5242f69a' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_antdesign_6495d35d from 'nuxt_plugin_antdesign_6495d35d' // Source: ../plugins/ant-design.js (mode: 'all')
import nuxt_plugin_addserverpath_f05e206c from 'nuxt_plugin_addserverpath_f05e206c' // Source: ../plugins/add-server-path.js (mode: 'all')
import nuxt_plugin_axios_5659d192 from 'nuxt_plugin_axios_5659d192' // Source: ../plugins/axios.js (mode: 'all')
import nuxt_plugin_tooltip_a5fff1ec from 'nuxt_plugin_tooltip_a5fff1ec' // Source: ../plugins/tooltip.js (mode: 'all')
import nuxt_plugin_d3delaunay_1e39ec70 from 'nuxt_plugin_d3delaunay_1e39ec70' // Source: ../plugins/d3-delaunay.js (mode: 'all')
import nuxt_plugin_vuethemask_0a766a32 from 'nuxt_plugin_vuethemask_0a766a32' // Source: ../plugins/vue-the-mask.js (mode: 'all')
import nuxt_plugin_vueselect_af0f7784 from 'nuxt_plugin_vueselect_af0f7784' // Source: ../plugins/vue-select.js (mode: 'all')
import nuxt_plugin_vuecustomscrollbar_10ef8bf0 from 'nuxt_plugin_vuecustomscrollbar_10ef8bf0' // Source: ../plugins/vue-custom-scrollbar.js (mode: 'all')
import nuxt_plugin_echartsclient_2a0215a2 from 'nuxt_plugin_echartsclient_2a0215a2' // Source: ../plugins/echarts.client.js (mode: 'client')
import nuxt_plugin_sentryserver_44f1affb from 'nuxt_plugin_sentryserver_44f1affb' // Source: ../plugins/sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_418f831a from 'nuxt_plugin_sentryclient_418f831a' // Source: ../plugins/sentry.client.js (mode: 'client')
import nuxt_plugin_infiniteloading_68d2fb1c from 'nuxt_plugin_infiniteloading_68d2fb1c' // Source: ../plugins/infiniteloading (mode: 'client')
import nuxt_plugin_vuefinalmodal_4feb7bbe from 'nuxt_plugin_vuefinalmodal_4feb7bbe' // Source: ../plugins/vue-final-modal.js (mode: 'client')
import nuxt_plugin_wysiwygeditor_070380f4 from 'nuxt_plugin_wysiwygeditor_070380f4' // Source: ../plugins/wysiwyg-editor.js (mode: 'client')
import nuxt_plugin_deferredanalyticsclient_2882ed6c from 'nuxt_plugin_deferredanalyticsclient_2882ed6c' // Source: ../plugins/deferred-analytics.client.js (mode: 'client')
import nuxt_plugin_libnuxtclientinitpluginclient70429504_3b3e5c26 from 'nuxt_plugin_libnuxtclientinitpluginclient70429504_3b3e5c26' // Source: ./lib.nuxt-client-init.plugin.client.70429504.js (mode: 'client')
import nuxt_plugin_auth_6ecf7bc6 from 'nuxt_plugin_auth_6ecf7bc6' // Source: ./auth.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Vistat","htmlAttrs":{"lang":"ru"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":""},{"name":"format-detection","content":"telephone=no"}],"link":[{"rel":"shortcut icon","href":"\u002Ffavicon.png"},{"rel":"preconnect","href":"https:\u002F\u002Ffonts.googleapis.com","crossorigin":"crossorigin"},{"rel":"preconnect","href":"https:\u002F\u002Ffonts.gstatic.com","crossorigin":"crossorigin"}],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_7159d61d === 'function') {
    await nuxt_plugin_plugin_7159d61d(app.context, inject)
  }

  if (typeof nuxt_plugin_vlazyload_9959e13e === 'function') {
    await nuxt_plugin_vlazyload_9959e13e(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtsvgsprite_db2f47de === 'function') {
    await nuxt_plugin_nuxtsvgsprite_db2f47de(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_5242f69a === 'function') {
    await nuxt_plugin_axios_5242f69a(app.context, inject)
  }

  if (typeof nuxt_plugin_antdesign_6495d35d === 'function') {
    await nuxt_plugin_antdesign_6495d35d(app.context, inject)
  }

  if (typeof nuxt_plugin_addserverpath_f05e206c === 'function') {
    await nuxt_plugin_addserverpath_f05e206c(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_5659d192 === 'function') {
    await nuxt_plugin_axios_5659d192(app.context, inject)
  }

  if (typeof nuxt_plugin_tooltip_a5fff1ec === 'function') {
    await nuxt_plugin_tooltip_a5fff1ec(app.context, inject)
  }

  if (typeof nuxt_plugin_d3delaunay_1e39ec70 === 'function') {
    await nuxt_plugin_d3delaunay_1e39ec70(app.context, inject)
  }

  if (typeof nuxt_plugin_vuethemask_0a766a32 === 'function') {
    await nuxt_plugin_vuethemask_0a766a32(app.context, inject)
  }

  if (typeof nuxt_plugin_vueselect_af0f7784 === 'function') {
    await nuxt_plugin_vueselect_af0f7784(app.context, inject)
  }

  if (typeof nuxt_plugin_vuecustomscrollbar_10ef8bf0 === 'function') {
    await nuxt_plugin_vuecustomscrollbar_10ef8bf0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_echartsclient_2a0215a2 === 'function') {
    await nuxt_plugin_echartsclient_2a0215a2(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_44f1affb === 'function') {
    await nuxt_plugin_sentryserver_44f1affb(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_418f831a === 'function') {
    await nuxt_plugin_sentryclient_418f831a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_infiniteloading_68d2fb1c === 'function') {
    await nuxt_plugin_infiniteloading_68d2fb1c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuefinalmodal_4feb7bbe === 'function') {
    await nuxt_plugin_vuefinalmodal_4feb7bbe(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_wysiwygeditor_070380f4 === 'function') {
    await nuxt_plugin_wysiwygeditor_070380f4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_deferredanalyticsclient_2882ed6c === 'function') {
    await nuxt_plugin_deferredanalyticsclient_2882ed6c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_libnuxtclientinitpluginclient70429504_3b3e5c26 === 'function') {
    await nuxt_plugin_libnuxtclientinitpluginclient70429504_3b3e5c26(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_6ecf7bc6 === 'function') {
    await nuxt_plugin_auth_6ecf7bc6(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
